import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { 
    CryptoCurrenciesResponse,
    ValidateAddressResponse,
    DepositResponse,
    WithdrawalResponse,
    EstimatePriceResponse,
    CancelWithdrawalResponse
} from 'src/types/responses/crypto-responses';
import {
    ValidateAddressRequest,
    DepositRequest,
    WithdrawalRequest,
    EstimatePriceRequest,
    CancelWithdrawalRequest
} from 'src/types/requests/crypto-requests';
import { environment } from 'src/environments/environment';

export interface CryptoRailStatus {
    depositEnabled: boolean;
    withdrawalEnabled: boolean;
}

@Injectable({
  providedIn: 'root'
})
export class CryptProcessService {

    constructor(private http: HttpClient) { }

    httpOptions = {
        headers: new HttpHeaders({
            'Content-Type': 'application/json',
        }),
    };

    getCryptoCurrencies(): Observable<CryptoCurrenciesResponse> {
        const url = environment.apiUrl + `/crypto-payment/currencies`;
        return this.http.get<CryptoCurrenciesResponse>(url, this.httpOptions);
    }

    // Rail kill-switches (betAdmin-toggled). The pickers hide the crypto
    // card for a disabled direction.
    getRailStatus(): Observable<{ error: boolean; data: CryptoRailStatus }> {
        const url = environment.apiUrl + `/crypto-payment/status`;
        return this.http.get<{ error: boolean; data: CryptoRailStatus }>(url, this.httpOptions);
    }

    validateAddress(request: ValidateAddressRequest): Observable<ValidateAddressResponse> {
        const url = environment.apiUrl + `/crypto-payment/validate-address`;
        return this.http.post<ValidateAddressResponse>(url, request, this.httpOptions);
    }

    createDeposit(request: DepositRequest): Observable<DepositResponse> {
        const url = environment.apiUrl + `/crypto-payment/deposit`;
        return this.http.post<DepositResponse>(url, request, this.httpOptions);
    }

    createWithdrawal(request: WithdrawalRequest): Observable<WithdrawalResponse> {
        const url = environment.apiUrl + `/crypto-payment/withdrawal`;
        return this.http.post<WithdrawalResponse>(url, request, this.httpOptions);
    }

    estimatePrice(request: EstimatePriceRequest): Observable<EstimatePriceResponse> {
        const url = environment.apiUrl + `/crypto-payment/estimate-price`;
        return this.http.post<EstimatePriceResponse>(url, request, this.httpOptions);
    }

    cancelWithdrawal(request: CancelWithdrawalRequest): Observable<CancelWithdrawalResponse> {
        const url = environment.apiUrl + `/crypto-payment/withdrawal/${request.transactionId}/cancel`;
        return this.http.get<CancelWithdrawalResponse>(url, this.httpOptions);
    }
}


